import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { OuiTagModule } from 'omnium-ui/tag';

type ConsultantSubscriptionStatus = 'subscribed' | 'terminationScheduled' | 'notSubscribed';
type TagStatus = 'completed' | 'in-progress' | 'pending';

@Component({
  selector: 'dbw-consultant-subscription-tag',
  imports: [OuiTagModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <oui-tag type="status" size="big" [status]="tagStatus()">
      {{ label() }}
    </oui-tag>
  `
})
export class ConsultantSubscriptionTagComponent {
  readonly isSubscribed = input(false);
  readonly subscriptionStatus = input<ConsultantSubscriptionStatus | string | null | undefined>(undefined);

  protected readonly label = computed(() => {
    switch (this.normalizedStatus()) {
      case 'subscribed':
        return 'Abonné';
      case 'terminationScheduled':
        return "Désabonnement programmé";
      default:
        return 'Non abonné';
    }
  });

  protected readonly tagStatus = computed<TagStatus>(() => {
    switch (this.normalizedStatus()) {
      case 'subscribed':
        return 'completed';
      case 'terminationScheduled':
        return 'in-progress';
      default:
        return 'pending';
    }
  });

  private readonly normalizedStatus = computed<ConsultantSubscriptionStatus>(() => {
    const status = this.subscriptionStatus();

    if (status === 'subscribed' || status === 'terminationScheduled' || status === 'notSubscribed') {
      return status;
    }

    return this.isSubscribed() ? 'subscribed' : 'notSubscribed';
  });
}
